import React from 'react';
import PropTypes from 'prop-types';
import MuiToolbar from '@material-ui/core/Toolbar';
import { withStyles, makeStyles } from '@material-ui/core/styles';
import MuiIconButton from '@material-ui/core/IconButton';
import MenuIcon from '@material-ui/icons/Menu';
import clsx from 'clsx';
import { Breadcrumb } from '../Breadcrumb';

const StyledToolbar = withStyles({
    root: {
        padding: '0px'
    }
})(MuiToolbar);

const StyledIconButton = withStyles({
    root: {}
})(MuiIconButton);

const useStyles = makeStyles(theme => ({
    menuButton: {
        marginRight: theme.spacing(2)
    },
    hide: {
        display: 'none'
    }
}));

const Toolbar = ({ handleDrawerOpen, menuOpen }) => {
    const classes = useStyles();
    return (
        <StyledToolbar>
            <StyledIconButton
                color='default'
                aria-label='open drawer'
                onClick={handleDrawerOpen}
                edge='start'
                className={clsx(classes.menuButton, menuOpen && classes.hide)}
            >
                <MenuIcon />
            </StyledIconButton>
            <Breadcrumb />
        </StyledToolbar>
    );
};

Toolbar.propTypes = {
    handleDrawerOpen: PropTypes.func.isRequired,
    menuOpen: PropTypes.bool.isRequired
};

export { Toolbar };
export default Toolbar;
